import { sharedEn } from '@cold-ambulance/ui';

const en = {
  ...sharedEn,
  common: {
    email: 'Email',
    password: 'Password',
    signIn: 'Sign In',
    next: 'Next',
    save: 'Save',
    saving: 'Saving',
    send: 'Send',
    confirm: 'Confirm',
    processing: 'Processing',
    back: 'Back',
    viewAll: 'View All',
    viewDetails: 'View Details',
    delete: 'Delete',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading',
    submit: 'Submit',
  },
  nav: {
    dashboard: 'Dashboard',
    myRequests: 'My Requests',
    payments: 'Payments',
    profile: 'Profile',
  },
  header: {
    welcome: 'Welcome',
    notifications: 'Notifications',
    noNotifications: 'No new notifications',
    profileData: 'Profile Data',
    logout: 'Logout',
    companyLogo: 'Company Logo',
  },
  home: {
    title: 'Dashboard',
    needMedicalService: 'Do you need a medical service?',
    requestDescription: 'Request',
    requestDescriptionBold: 'an ambulance, mobile clinic, or other services,',
    requestDescriptionEnd:
      'and we will connect you directly with approved service providers to secure your required services easily',
    requestMedicalService: 'Request Medical Service',
    myRequests: 'My Requests',
    noRequestsTitle: 'No requests currently',
    noRequestsDescription: 'Start by adding a new request to display it here',
    accountUnderReview:
      'Your account is still under review by the administrator',
    defaultProjectName: 'Project',
    viewOffer: 'View Offer',
    activeService: 'Active Service',
  },
  signin: {
    title: 'Sign in as user',
    noAccount: "Don't have an account yet?",
    signUp: 'Sign up with us',
    forgotPassword: 'Forgot password?',
    signingIn: 'Signing in...',
  },
  signup: {
    registerWithUs: 'Register with us',
    haveAccount: 'Have an account?',
    stepTitle: 'Detailed Information',
    confirmPassword: 'Confirm Password',
    creatingAccount: 'Creating account...',
    serviceRequesterName: 'Service Requester Name',
    contactPerson: 'Contact Person',
    continuing: 'Continuing...',
    requiredDocuments: 'Required Documents',
    termsAccept: 'I agree to the terms and conditions',
    termsAcceptPrefix: 'I agree to the',
    termsAnd: 'and the',
    privacyPolicy: 'Usage and Privacy Policy',
    customerAgreement: 'Client Subscription Agreement',
  },
  profile: {
    title: 'Profile Data',
    generalInfo: 'General Information',
    contactInfo: 'Contact Information',
    requiredDocuments: 'Required Documents',
    serviceProviderName: 'Service Provider Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    contactJobTitle: 'Contact Person Job Title',
    phoneNumber: 'Phone Number',
  },
  placeholders: {
    companyName: 'Al-Ruwad Medical Company',
    firstName: 'Mishari',
    lastName: 'Al-Enazi',
    projectManager: 'Project Manager',
  },
  documents: {
    bankCertificate: 'Bank Certificate',
    commercialRegistration: 'Commercial Registration',
    taxCertificate: 'Tax Certificate',
    zakaCertificate: 'Zakat and Tax Authority Registration',
    companyLogo: 'Company Logo',
    nationalAddress: 'National Address Certificate',
  },
  requests: {
    myRequests: 'My Requests',
    draftsTitle: 'Draft Requests',
    draftBadge: 'Draft',
    lastSaved: 'Last saved {{value}}',
    continueEditing: 'Continue Editing',
    deleteDraft: 'Delete Draft',
    deleteDraftConfirmation: 'Delete this draft?',
    noDrafts: 'No drafts yet. Start a new request and it will appear here.',
    submittedRequests: 'Submitted Requests',
    draftServicesCount_one: '{{count}} requested service selected',
    draftServicesCount_other: '{{count}} requested services selected',
    draftSummaryEmpty: 'No services selected yet',
    requestDetails: 'Request Details',
    requiredService: 'Required Service',
    newRequest: 'New Service Request',
    submitRequest: 'Submit Request',
    requestSentSuccess: 'Your request has been sent successfully!',
    requestSentNotification:
      'You will receive a notification when offers arrive through the notification system.',
    goToDashboard: 'Go to Dashboard',
    additionalDocuments: 'Submit Additional Documents',
    submitting: 'Submitting...',
    submitAdditionalDocs: 'Submit Additional Documents',
    searchLocation: 'Search for location',
  },
  services: {
    ambulanceWithDriver: 'Ambulance with Driver',
    ambulanceWithoutDriver: 'Ambulance without Driver',
    ambulanceWithoutDriverAlt: 'Ambulance without Driver',
    ambulance4x4WithDriver: '4x4 Ambulance with Driver',
    ambulance4x4WithoutDriver: '4x4 Ambulance without Driver',
    mobileClinicBasic: 'Basic Mobile Clinic',
    mobileClinicAdvanced: 'Advanced Mobile Clinic',
    medicalEquipment: 'Medical Equipment',
    equipment: 'equipment',
    ambulance: 'Ambulance',
    paramedic: 'Paramedic',
    nurse: 'Nurse',
  },
  newRequest: {
    serviceRequest: 'Service Request',
    serviceRequestSubtitle: 'Vehicles, medical staff, clinics',
    equipmentRequest: 'Medical Equipment & Supplies Request',
    equipmentRequestSubtitle: 'Purchase or rent from vendors',
    changeRequestTypeTitle: 'Change request type?',
    changeRequestTypeDescription:
      'Your selections in the sections for the current type will be cleared. This cannot be undone.',
    changeRequestTypeConfirm: 'Change type',
    serviceDetails: 'Required Service Details',
    projectName: 'Project Name',
    projectEntity: 'Project Entity',
    government: 'Government Sector',
    private: 'Private Sector',
    serviceType: 'Required Service Type',
    ambulanceWithDriver: 'Ambulance with Driver',
    ambulanceWithoutDriver: 'Ambulance without Driver',
    ambulance4x4WithDriver: '4x4 Ambulance with Driver',
    ambulance4x4WithoutDriver: '4x4 Ambulance without Driver',
    basicClinic: 'Basic Mobile Clinic',
    advancedClinic: 'Advanced Mobile Clinic',
    count: 'Count',
    specifiedEquipment: 'Specified Medical Equipment and Supplies',
    medicalStaffTypes: 'Emergency Medical Staff Types',
    paramedic: 'Paramedic',
    paramedicSubtitle:
      'Highly skilled paramedics capable of providing specialized care.',
    paramedicSpecialist: 'Paramedic Specialist',
    paramedicTechnician: 'Paramedic Technician',
    nurses: 'Nurses',
    nursesSubtitle:
      "Certified nurses (SN1 with bachelor's degree, SN2 with diploma).",
    nurseSpecialist: 'Nurse Specialist',
    nurseTechnician: 'Nurse Technician',
    doctors: 'Doctors',
    doctorsSubtitle:
      'Including General Practitioners (GPs) and Emergency Medical Care Specialists.',
    specializationPlaceholder:
      'Specialization (e.g., General Practitioner, Internal Medicine)',
    addDoctor: 'Add Doctor',
    medicalEquipment: 'Medical Equipment and Supplies',
    medicalEquipmentSubtitle:
      'Additional medical equipment not available in ambulances',
    equipmentNamePlaceholder: 'e.g., Ventilator, Heart Monitor',
    quantity: 'Quantity',
    addEquipment: 'Add Equipment',
    bookingPeriodLocation: 'Booking Period & Location',
    bookingPeriod: 'Booking Period',
    fromHour: 'From',
    toHour: 'To',
    bookingDuration: 'Booking Duration:',
    workHoursPerDay: 'Work Hours / Day:',
    contractPaymentTerms: 'Contract & Payment Terms',
    proposalDeadline: 'Proposal Deadline for Vendors',
    paymentSchedule: 'Payment Schedule',
    monthly: 'Monthly',
    deliverables: 'Deliverables',
    selectPaymentSplit: 'Select payment split',
    month: 'Month',
    milestones: 'Milestones',
    total: 'Total:',
    deliverable: 'Deliverable',
    firstPayment: 'First Payment',
    addMilestone: 'Add Milestone',
    remaining: '% remaining',
    minTwoMilestones: 'At least two milestones are required',
    bankGuaranteePercent: 'Bank Guarantee Percentage',
    noBankGuarantee: '0% = No bank guarantee required',
    kpis: 'Performance Indicators',
    kpiPlaceholder:
      'e.g., Response within 10 minutes, 95% customer satisfaction rate',
    addKpi: 'Add Performance Indicator',
    kpiDescription:
      'These indicators determine the deduction percentage from the final payment (0-20%)',
    additionalDetails: 'Additional Details',
    isolatedArea: 'Work Area Nature (isolated/remote area)',
    housingTransport:
      'Will housing and transportation be provided (from housing to work site and back)',
    mealsProvided: 'Will meals be provided for the work crew?',
    additionalNotes: 'Additional Notes',
    optional: '(optional)',
    saving: 'Saving...',
    saved: 'Saved',
    notSpecified: 'Not specified',
    noServicesSelected: 'No services selected',
    noStaffSelected: 'No staff selected',
    noEquipmentAdded: 'No equipment added',
  },
  preview: {
    title: 'Request Preview',
    hidePreview: 'Hide Preview',
    showPreview: 'Show Preview',
    projectDetails: 'Project Details',
    medicalStaff: 'Medical Staff',
    medicalEquipment: 'Medical Equipment and Supplies',
    bookingPeriodLocation: 'Booking Period & Location',
    contractPaymentTerms: 'Contract & Payment Terms',
    additionalDetails: 'Additional Details',
    projectName: 'Project Name',
    projectEntity: 'Project Entity',
    government: 'Government Sector',
    private: 'Private Sector',
    proposalDeadline: 'Proposal Deadline:',
    bankGuarantee: 'Bank Guarantee:',
    paymentSystem: 'Payment System:',
    kpis: 'Performance Indicators:',
    isolatedArea: 'Isolated/Remote Area',
    housingTransport: 'Housing & Transportation',
    meals: 'Meals',
    notes: 'Notes:',
    equipment: 'Equipment:',
    paramedics: 'Paramedics',
    nurses: 'Nurses',
    doctorsLabel: 'Doctors',
    specialist: 'Specialist:',
    technician: 'Technician:',
    quantityLabel: 'Quantity:',
  },
  offers: {
    allOffers: 'All Submitted Offers',
    submittedOffers: 'Submitted Offers',
    noOffersTitle: 'Latest Submitted Offers',
    noOffers: 'No offers currently',
    noOffersReceived: 'No offers have been received yet',
    offerDetails: 'Offer Details',
    offeredPrice: 'Offered Price',
    submissionDate: 'Submission Date',
    offerProvider: 'Offer Provider',
  },
  acceptOffer: {
    reviewOffer: 'Review Offer',
    financialOffer: 'Financial Offer',
    previewOfferDetails: 'Preview the submitted offer details',
    offerSummary: 'Offer Summary',
    vendor: 'Vendor',
    offerProvider: 'Offer Provider',
    offerPrice: 'Offer Price',
    platformFee: 'Platform Fee (10%)',
    vat: 'VAT (15%)',
    totalPrice: 'Total Price',
    vendorNotes: 'Vendor Notes',
    requiredDocuments: 'Required Documents from Vendor',
    requiredDocumentsDescription:
      'The vendor will be asked to upload these documents before completing the contract',
    noDocumentsNeeded: "I don't need additional documents",
    documentNamePlaceholder: 'Document name (e.g., Commercial Registration)',
    bankGuaranteeRequired: 'Bank Guarantee Required',
    bankGuaranteeAutoAdded:
      '"Bank Guarantee Letter" will be automatically added to required documents',
  },
  contract: {
    offerDetails: 'Offer Details',
    reviewOfferAndContract:
      'Review the offer and contract and complete the electronic signature',
    financialOffer: 'Financial Offer',
    previewFinancialOffer: 'Preview the financial offer details',
    vendorSignature: 'Vendor Signature',
    yourSignature: 'Your Signature',
    contractSignedSuccess: 'Contract signed successfully',
    contractSignedBothParties:
      'The contract has been signed by both parties. Please upload the payment proof (TT) to complete the process.',
    ttDeadline: 'Payment Proof Upload Deadline:',
    awaitingVendorSignature: 'Awaiting Vendor Signature',
    awaitingVendorSignatureDescription:
      "Your contract has been signed successfully. We are awaiting the vendor's signature to complete the process.",
    backToRequest: 'Back to Request',
    error: 'Error',
    errorLoadingData: 'An error occurred while loading data',
  },
  offerAccepted: {
    offerAcceptedSuccess: 'Offer accepted successfully',
    noDocumentsRequired:
      'The contract has been sent to your email for electronic signature. You can track the signature status.',
    viewContractStatus: 'View Contract Status',
    documentsSentSuccess:
      'Additional document request sent to vendor successfully',
    documentsSentDescription:
      'Our team will review the files and contact you soon. Once we verify the documents, we will provide you with the next steps.',
  },
  requestDetails: {
    ttUploadTitle: 'Upload Bank Transfer Proof',
    deadline: 'Deadline:',
    day: 'day',
    days: 'days',
    remaining: 'remaining',
    medhubTransfer: 'MedHub Transfer (10%)',
    vendorTransfer: 'Vendor Transfer (10%)',
    medhubBankInfo: 'Bank Account Information - MedHub',
    transferToAccount: 'Please transfer the amount to the following account',
    reviewedByAdmin: 'Reviewed by: Administration',
    reviewedByVendor: 'Reviewed by: Vendor',
    ttRejected: 'Payment proof rejected:',
    ttUploaded: 'Payment proof uploaded',
    awaitingReview: 'Awaiting review',
    vendorBankCertNotUploaded:
      'Vendor has not uploaded the bank certificate yet',
    bankCertDownloadError:
      'An error occurred while downloading the bank certificate',
  },
  forgotPassword: {
    title: 'Forgot your password?',
    subtitle: 'Enter your email to reset your password.',
    emailSentTitle: 'Operation Successful',
    emailSentSubtitle: 'We have sent a password reset link to your email.',
    setNewPassword: 'Set New Password',
    setNewPasswordSubtitle:
      'Please enter your new password to update your account.',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordChanged:
      'Password changed successfully, redirecting to sign in page...',
    passwordChangedTitle: 'Password Changed Successfully!',
    useNewPassword: 'You can use your new password.',
    invalidCode: 'Verification code is invalid or expired',
    errorOccurred: 'An error occurred',
    backToRecovery: 'Back to Password Recovery',
  },
  errors: {
    resetLinkNotFound: 'Password reset link not found',
    verificationCodeNotFound: 'Verification code not found in link',
    verificationCodeInvalid: 'Verification code is invalid or expired',
    accountUnderReview:
      'Your account is still under review by the administrator',
  },
} as const;

export default en;
